import { risks } from '../data/risks';

export default function RiskMatrix() {
  return (
    <section id="risks" className="mx-auto max-w-6xl px-6 py-32">
      <h2 className="font-display text-4xl md:text-6xl tracking-tight2 mb-4">
        New controls for new failure modes.
      </h2>
      <p className="text-ink-dim text-lg max-w-2xl mb-12">
        A 15-row matrix mapping the risks the agent era introduced to the
        control surface that contains them.
      </p>
      <div className="overflow-x-auto rounded-2xl border hairline">
        <table className="w-full text-sm">
          <thead className="bg-elevated/60 text-ink-dim">
            <tr>
              <th className="text-left p-4 font-medium">Risk</th>
              <th className="text-left p-4 font-medium">Control surface</th>
              <th className="text-left p-4 font-medium">Owners</th>
              <th className="text-left p-4 font-medium">Anchor</th>
            </tr>
          </thead>
          <tbody>
            {risks.map((r) => (
              <tr key={r.risk} className="border-t hairline align-top">
                <td className="p-4 text-ink">{r.risk}</td>
                <td className="p-4 text-ink-dim">{r.control}</td>
                <td className="p-4 text-ink-dim">{r.owners}</td>
                <td className="p-4 text-ink-dim font-mono text-xs">
                  {r.anchor}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
